// @ts-check
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import * as Sentry from '@sentry/browser'

import { verifyWidget } from '@/store/api'

export function useWidgetVerify () {
  const route = useRoute()
  const router = useRouter()
  const success = ref()
  const loading = ref(true)

  const envelopeFingerprint = route.params.envelopeFingerprint
  const query = new URLSearchParams({
    expires: Array.isArray(route.query.expires) ? route.query.expires[0] : route.query.expires,
    signature: Array.isArray(route.query.signature) ? route.query.signature[0] : route.query.signature
  }).toString()

  verifyWidget({ envelopeFingerprint, query })
    .then((response) => {
      success.value = response.status === 200
    })
    .catch((error) => {
      if (error.response && error.response.status === 409) {
        success.value = false
      } else if (error.response) {
        Sentry.captureException(error.response)

        router.push({
          name: 'PageError',
          params: {
            errorMessage: error.response.data.message,
            errorCode: error.response.status
          }
        })
      } else {
        Sentry.captureException(error, {
          extra: error
        })

        router.push({
          name: 'PageError',
          params: {
            errorMessage: error.message || error,
            errorCode: '0'
          }
        })
      }
    }).finally(() => {
      loading.value = false
    })

  return {
    success,
    loading
  }
}
